
import { Component, Vue } from 'vue-property-decorator'
@Component({
    name: 'BottomBtn'
})
export default class extends Vue {
    private questionFeedback() {
        this.$jump('/feedback')
    }
}
